import React from 'react';
import Stack from '@/components/stack';
import {StackProps} from '@/components/stack/StackProps';
import useIsMobile from '@/hooks/use-is-mobile';

interface ResponsiveStackProps extends Omit<StackProps, 'direction'> {
  /**
   * The content to be stacked
   */
  children: React.ReactNode;

  /**
   * Direction when on mobile (defaults to 'column')
   */
  mobileDirection?: 'row' | 'column';

  /**
   * Direction when on desktop (defaults to 'row')
   */
  desktopDirection?: 'row' | 'column';
}

function ResponsiveStack({
  children,
  mobileDirection = 'column',
  desktopDirection = 'row',
  ...rest
}: ResponsiveStackProps) {
  const isMobile = useIsMobile();
  const direction = isMobile ? mobileDirection : desktopDirection;

  return (
    <Stack direction={direction} {...rest}>
      {children}
    </Stack>
  );
}

export default ResponsiveStack;
